// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"8e64bb78","100":"acde9463","142":"ecdac326","272":"915bd842","292":"2ba62ff5","677":"4b2e2192"}[chunkId] + ".chunk.js";
};